export default {
    CHANGE_NEW_PASSWORD: '@@resetPassword/CHANGE_NEW_PASSWORD',
    CHANGE_CONFIRM_PASSWORD: '@@resetPassword/CHANGE_CONFIRM_PASSWORD',
    PASSWORDS_DO_NOT_MATCH: '@@resetPassword/PASSWORDS_DO_NOT_MATCH',
    RESET_KEY_INVALID: '@@resetPassword/RESET_KEY_INVALID',
    RESET_KEY_VALID: '@@resetPassword/RESET_KEY_VALID',
    RESET_PASSWORD_SUBMITTED: '@@resetPassword/RESET_PASSWORD_SUBMITTED',
    RESET_PASSWORD_FAILURE: '@@resetPassword/RESET_PASSWORD_FAILURE',
    RESET_PASSWORD_FAILURE_EXPIRED_CODE:
        '@@resetPassword/RESET_PASSWORD_FAILURE_EXPIRED_CODE',
    RESET_PASSWORD_FAILURE_ERROR_FOR_USER:
        '@@resetPassword/RESET_PASSWORD_FAILURE_ERROR_FOR_USER',
    RESET_PASSWORD_SUCCESS: '@@resetPassword/SUBMIT_PASSWORD_SUCCESS',
    TRACK_FOCUS_NEW_PASSWORD: '@@resetPassword/TRACK_FOCUS_NEW_PASSWORD',
    TRACK_CHANGE_NEW_PASSWORD: '@@resetPassword/TRACK_CHANGE_NEW_PASSWORD',
    BLUR_NEW_PASSWORD: '@@resetPassword/TRACK_BLUR_NEW_PASSWORD',
    TRACK_FOCUS_CONFIRM_PASSWORD:
        '@@resetPassword/TRACK_FOCUS_CONFIRM_PASSWORD',
    TRACK_CHANGE_CONFIRM_PASSWORD:
        '@@resetPassword/TRACK_CHANGE_CONFIRM_PASSWORD',
    BLUR_CONFIRM_PASSWORD: '@@resetPassword/TRACK_BLUR_CONFIRM_PASSWORD',
};
